import { Text } from '@simplywallst/ui-core';
import Tooltip from '@/components/Tooltip';
import { Term, TooltipTitle } from './Styled';

interface Props {
  title: string;
  value: string;
  tooltip?: string | null;
}

export const KeyMetric = ({ title, value, tooltip }: Props) => {
  return (
    <>
      <Text typography="largeStrong">{value}</Text>
      <Text typography="xSmall" opacity={0.7} color={'whiteRGBA'}>
        {typeof tooltip !== 'undefined' ? (
          <Tooltip
            title={<TooltipTitle>{tooltip}</TooltipTitle>}
            light
            openDelay={300}
          >
            <Term>{title}</Term>
          </Tooltip>
        ) : (
          title
        )}
      </Text>
    </>
  );
};
